import { useAppContext } from '@/contexts/AppContext';
import { days, formatTime } from '@/utils/dates';
import type { FC } from 'react';

interface Props {
  className?: string;
}

const OfficeHours: FC<Props> = ({ className = 'space-y-1 text-sm' }) => {
  const { community } = useAppContext();

  if (!community.officeHours || Object.keys(community.officeHours).length === 0) {
    return null;
  }

  return (
    <ul className={className}>
      {days.map((day) => (
        <li key={`office-hour-${day.label}`}>
          {day.label}:{' '}
          {community.officeHours?.[day.value]?.[0] && community.officeHours?.[day.value]?.[1]
            ? `${formatTime(community.officeHours?.[day.value][0])} - ${formatTime(community.officeHours?.[day.value][1])}`
            : 'Closed'}
        </li>
      ))}
    </ul>
  );
};

export default OfficeHours;
